export default {
  mounted () {
    this.$on('clipboard-copy', (payload) => {
      this.copyToClipboard(payload)
    })
  },
  methods: {
    /**
     * Copies the given value to the keyboard.
     */
    copyToClipboard (value) {
      try {
        // Step 1: create a textarea element.
        // It is capable of holding linebreaks (newlines) unlike "input" element
        const myFluffyTextarea = document.createElement('textarea')

        // Step 2: Store your string in innerHTML of myFluffyTextarea element
        myFluffyTextarea.innerHTML = value

        // Step3: find an id element within the body to append your myFluffyTextarea there temporarily
        const parentElement = document.getElementById('ws-app-ghost-copy-parent-element')
        parentElement.appendChild(myFluffyTextarea)

        // Step 4: Simulate selection of your text from myFluffyTextarea programmatically
        myFluffyTextarea.select()

        // Step 5: simulate copy command (ctrl+c)
        // now your string with newlines should be copied to your clipboard
        document.execCommand('copy')

        // Step 6: Now you can get rid of your fluffy textarea element
        parentElement.removeChild(myFluffyTextarea)
      } catch (err) {
        console.error('No copy to clipboard support present.')
        throw err
      }
    }
  }
}
